export const PABA_STATES = {
	AUTH: 'AUTH',
	SIGNATURES: 'SIGNATURES',
	TECHNICAL_ERROR: 'TECHNICAL_ERROR'
};

export const AUTH_STATES = {
	LOGIN: 'LOGIN',
	TWO_FACTOR_AUTH: 'TWO_FACTOR_AUTH',
	CHANGE_PASSWORD: 'CHANGE_PASSWORD'
};

export const LOGIN_STATUSES = {
	SMS: 'SMS',
	FINAL: 'FINAL',
	CHANGE_PASS: 'CHANGE_PASS'
};

export const LOGIN_RESPONSE_ERRORS = {
	CAPTCHA: 'captcha',
	CREDENTIALS: 'credentials',
	FORBIDDEN: 'forbidden'
};

export const SMS_RESPONSE_ERRORS = {
	SMS_CODE: 'sms_code',
	CHANGE_PASSWORD: 'change_password'
};

export const CHANGE_PASS_RESPONSE_ERRORS = {
	USED: 'used_password',
	WEAK: 'weak_password',
	TOO_SHORT: 'too_short_password',
	PASSWORD_FORMAT: 'password_format'
};
